enum State {
  Start = "START",
  Patient = "PATIENT",
  Visitor = "VISITOR",
  Companion = "COMPANION",
  Inpatient = "INPATIENT",
  Outpatient = "OUTPATIENT",
  PatientHasCPID = "PATIENT_CPID",
  PatientHasNoCPID = "PATIENT_CPID_MISSING",
  Back = "BACK",
  Form = "FORM",
}

export default State;
